export const SET_IS_MODAL_OPENED = 'SET_IS_MODAL_OPENED' as const;
export const setIsModalOpened = (isModalOpened: boolean) => ({
  type: SET_IS_MODAL_OPENED,
  isModalOpened,
});
export type SetIsModalOpened = ReturnType<typeof setIsModalOpened>;

export type ChangePasswordPageActions = SetIsModalOpened;
